import { render, staticRenderFns } from "./v-fagforening-for-mig.vue?vue&type=template&id=7fa7833d&scoped=true&"
import script from "./v-fagforening-for-mig.vue?vue&type=script&lang=js&"
export * from "./v-fagforening-for-mig.vue?vue&type=script&lang=js&"
import style0 from "./v-fagforening-for-mig.vue?vue&type=style&index=0&id=7fa7833d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa7833d",
  null
  
)

export default component.exports